
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/armored-rentals/[slug]",
      function () {
        return require("private-next-pages/armored-rentals/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/armored-rentals/[slug]"])
      });
    }
  